import React, { useEffect, useState } from 'react';

import { Container, Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';

import { casesDefaultCriteria } from '../../blocs/cases.bloc';
import CaseFilters from '../../components/creatorDashboard/CaseFilters';
import CaseList from '../../components/creatorDashboard/CaseList';
import { WorkspaceProductType } from '../../models/Workspace';
import useBlocRef from '../../utils/useBlocRef.hook';

export default () => {
  const [cases, setCases] = useState([]);
  const [totalCases, setTotalCases] = useState(0);
  const [searchCriteria, setSearchCriteria] = useState(casesDefaultCriteria);
  const [userDetails, setUserDetails] = useState(null);
  const history = useHistory();
  const blocRef = useBlocRef('creatorDashboardBloc');

  const handleFilterChange = (updatedCriteria) => {
    blocRef.current.updateSearchCriteria({ ...updatedCriteria, page: 0 });
  };

  const handleCriteriaChange = (updatedCriteria) => {
    blocRef.current.updateSearchCriteria(updatedCriteria);
  };

  const handleCaseClick = async (caseStudy) => {
    history.push(`/case-details?caseId=${caseStudy.id}`);
  };

  useEffect(() => {
    const casesSub = blocRef.current.cases$.subscribe(setCases);
    const totalSub = blocRef.current.total$.subscribe(setTotalCases);
    const searchCriteriaSub = blocRef.current.searchCriteria$.subscribe(setSearchCriteria);
    const userDetailsSub = blocRef.current.userDetails$.subscribe(setUserDetails);

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      blocRef.current.dispose();
      casesSub.unsubscribe();
      totalSub.unsubscribe();
      searchCriteriaSub.unsubscribe();
      userDetailsSub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (userDetails?.workspace?.productType) {
      const isWhiteGloveCreator = userDetails.workspace.productType === WorkspaceProductType.whiteGlove.value && ['patient', 'creator'].includes(userDetails.role);
      const lawFirm = userDetails.workspace.productType === WorkspaceProductType.LawFirm.value && ['admin', 'creator'].includes(userDetails.role);

      if (!isWhiteGloveCreator && !lawFirm) {
        history.push('/cases');
      }
    }
  }, [history, userDetails]);

  return (
    <Grid container style={{ padding: '2rem' }} component={Container}>
      <Grid item xs={12} className="mt-1" style={{ paddingLeft: '8px' }}>
        <CaseFilters onCriteriaChange={handleFilterChange} />
      </Grid>
      <Grid item xs={12} className="mt-2">
        <CaseList cases={cases} total={totalCases} onCriteriaChange={handleCriteriaChange} onCaseClick={handleCaseClick} page={searchCriteria.page} />
      </Grid>
    </Grid>
  );
};
